// Single source of truth for eraser sizing.
// Value is expressed in *screen pixels*; it is converted to scene units via `/ zoom`.

export const ERASER_RADIUS_PX = 10;
